<template>
    <b-container class="add-business">
        <div class="loader" v-if="loader">
            <loader />
        </div>

        <div class="order-form">
            <h1 style="padding-top:20px; padding-bottom:30px;">Add your Business</h1>

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="business">Business Name</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="business" type="text" v-model="business"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="pin">Create a PIN</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-input id="pin" type="number" :state="pinState" v-model="pin"></b-form-input>
                    <b-form-invalid-feedback class="left-align-text" id="input-live-feedback">
                    Enter a 4 Number PIN.
                    </b-form-invalid-feedback>
                  <b-form-text class="left-align-text" >Note: You will use your PIN to access Admin pages.</b-form-text>
                </b-col>
            </b-row>

            <b-row class="mt-4" align-h="center" align-v="center">
                <b-col cols="3" sm="2" md="2" lg="1">
                    <b-btn class="form-btn submit-btn" :disabled="business == '' || !pinState" @click="submitOrder">Add</b-btn>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import Loader from "../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
export default {
    components: {
        Loader
    },
    data() {
        return {
            business: '',
            pin: '',
            addBusinessApi: 'https://us-central1-readytextme.cloudfunctions.net/createBusiness',
            loader: false
        }
    },
    async created() {
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).get();
        if (userDoc.data().business != '') {
            this.$router.push({path: '/open'});
        }
    },
    methods: {
        async submitOrder () {
            // method to create new business
            this.loader = true;
            // object to send api
            const obj = {
                'uid': firebase.auth().currentUser.uid,
                 'business': this.business,
                 'pin': this.pin
            }

            // console.log(obj);
            // request api to create new business
            try {

                await axios.post(
                    this.addBusinessApi,
                    obj,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }
                )
                this.$router.push({path:'/open'});
                this.loader = false;
                // if (response.status == '200') {
                // }
                // console.log('order created');
            } catch (error) {
                console.log(error);
                this.loader = false;
            }
        },
    },

    computed: {
        pinState() {
            // method to make sure pin is greater than 3 and less than 5
            return this.pin.length > 3 && this.pin.length < 5 ? true : false
        }
    },
}
</script>

<style scoped>
    .add-order {
        padding-top: 80px;
    }

    .order-form {
        border: 1px solid #efefef;
        padding: 20px;
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0px 1px 8px 1px #efefef;
    }

    .form-row {
        padding: 10px 0px;
    }

    .loader {
        position: fixed;
        width: 350px;
        height: 350px;
        z-index: 100;
        padding-top: 70px;
        /* top: 0; */
        bottom: 30%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #c0c0c0;
        border-radius: 5px;
        transition: all 0.8s ease;
    }

    .add-business {
        padding-top: 100px;
    }

    .left-align-text {
        text-align: start;
    }
</style>
